import { ContentProps } from 'types';
import { isProductCards } from '../isProductCards';
import { isLayoutContainer } from '../isLayoutContainer';

const hasProductCards = (contents: ContentProps[]) =>
  contents.some((content) => {
    if (isProductCards(content)) {
      return true;
    }
    if (isLayoutContainer(content)) {
      return content.componentData.reference.some(
        (reference) => reference._content_type_uid === 'product_cards',
      );
    }
    return false;
  });

export default hasProductCards;
